import { inject, Injectable, TemplateRef} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class SbPageActionService {
  private readonly modalService = inject(NgbModal);

  private actions = new BehaviorSubject<TemplateRef<any>[]>([]);
  readonly actions$ = this.actions.asObservable();

  private addAction(ref: TemplateRef<any>) {
    if (this.modalService.hasOpenModals()) {
      return;
    }
    this.actions.next([...this.actions.value, ref]);
  }

  private removeAction(ref: TemplateRef<any>) {
    this.actions.next(this.actions.value.filter(r => r !== ref));
  }

  // Public API
  register(ref: TemplateRef<any>): () => void {
    this.addAction(ref);
    // Return cleanup function
    return () => this.removeAction(ref);
  }

  clearAll() {
    this.actions.next([]);
  }

}
